// extracted by mini-css-extract-plugin
export default {"groupName":"clientGroups_groupName__IoTmO"};